import "./Default.css";

const Default = () => {
  return (
    <div className="container-fluid default">
      <div>Paste some content and click on evaluate!!</div>
    </div>
  );
};

export default Default;
